import React from 'react';
import PropTypes from 'prop-types';

import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import {Typography} from '@mui/material';
import {styled} from '@mui/system';

import {concatUrl} from '../helpers/url';
import {checkUserRoles} from '../helpers/authentication';
import GlobalContext from '../helpers/context';
import {getCall, postCall} from '../helpers/request';



const StyledWorkspaces = styled('div')(({ theme }) =>({
    paddingTop: theme.custom.paper.top_space
}));

const StyledTitle = styled(Typography)(({ theme }) =>({
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize,
    fontWeight: theme.custom.font.bold
}));

const StyledFormControl = styled(FormControlLabel)(({ theme }) =>({
    fontFamily: theme.typography.fontFamily,
    marginRight: 30,
    '& .MuiFormControlLabel-label':{
        fontSize: theme.custom.font.medium
    }
}));


class WorkspacesPerUser extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            workspaces: []
        };

        this.accepted_roles = ['admin'];
        this.get_workspace_user_assignments_url = concatUrl(window.ROOT_URL, 'api', 'user', 'get_assigned_workspaces');
        this.update_workspace_user_assignment_url = concatUrl(window.ROOT_URL, 'api', 'user', 'update_workspace_assignment');
    }

    componentDidMount(){
        this.context.checkUserAccess(this.conditionCallback);
        this.getWorkspaceUserAssignments();
    }

    conditionCallback = (user) => {
        return checkUserRoles(user, this.accepted_roles);
    };

    stopPropagation = (event) => {
        event.stopPropagation();
    };

    // +++ get current workspace user assignments +++++++++++++++++++++++++++++++++++++++++++++++

    getWorkspaceUserAssignmentsFailed = () => {
        this.context.displayGlobalError('Backend service failure: Could not receive assigned workspaces list.');
    };

    getWorkspaceUserAssignmentsDone = (data, callback_failure) => {
        if(data && data.workspaces){
            this.setState({
                workspaces: data.workspaces
            });
        }else{
            callback_failure();
        }
    };

    getWorkspaceUserAssignments = () => {
        getCall(`${this.get_workspace_user_assignments_url}?id=${this.props.user_id}`, this.getWorkspaceUserAssignmentsDone, this.getWorkspaceUserAssignmentsFailed);
    };


    // +++ update workspace user assignment +++++++++++++++++++++++++++++++++++++++++++++++

    updateWorkspaceUserAssignmentFailed = () => {
        this.context.displayGlobalError('Backend service failure: Could not change the assignment between workspace and user.');
    };

    updateWorkspaceUserAssignmentDone = () => {
        this.getWorkspaceUserAssignments();
        this.context.displayGlobalInfo('The changes were successfully saved');
    };

    updateWorkspaceUserAssignment = workspace_group_key => event => {
        const data = {
            'user_id': this.props.user_id,
            'workspace_group_key': workspace_group_key,
            'assigned': event.currentTarget.checked
        };
        postCall(this.update_workspace_user_assignment_url, data, this.updateWorkspaceUserAssignmentDone, this.updateWorkspaceUserAssignmentFailed);
    };

    noWorkspacesInfo = () => {
        return (
            <Typography variant="caption">
                - No workspace available -
            </Typography>
        );
    };

    render() {
        return (
            <GlobalContext.Consumer>{() => (
                <StyledWorkspaces data-bt="workspaces">
                    <StyledTitle>
                        Workspace assignment
                    </StyledTitle>
                    {this.state.workspaces && this.state.workspaces.map((workspace) => <StyledFormControl
                        key={workspace.key}
                        control={
                            <Checkbox
                                checked={workspace.assigned}
                                onChange={this.updateWorkspaceUserAssignment(workspace.key)}
                                value={workspace.name}
                                data-ws-name={workspace.name}
                                data-bt="workspace_item"
                            />
                        }
                        label={`${workspace.name} (${workspace.id})`}
                    />)}
                    {!this.state.workspaces.length && this.noWorkspacesInfo()}
                </StyledWorkspaces>
            )}
            </GlobalContext.Consumer>
        );
    }
}

WorkspacesPerUser.contextType = GlobalContext;

WorkspacesPerUser.propTypes = {
    user_id: PropTypes.number.isRequired
};

export default WorkspacesPerUser;
